module.exports = __webpack_public_path__ + "img/process-transfer.e07f276d.png";